import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../core/pagination/datatable";
// import AddConfiguration from "../../core/modals/inventory/addConfiguration";
// import AddContactUs from "../../core/modals/inventory/addContactUs";
import {
  PlusCircle,
  RotateCcw,
} from "feather-icons-react/build/IconComponents";

import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { GetRequest, PatchRequest } from "../../Api/ApiFunctions";
import { ApiUrl, ConfUrl } from "../../Api/EndPoints";
import {
  DeletConfirmation,
  showDeleteConfirmationAlert,
} from "../MyComponents/SwalAlerts";
import { PermissionHandler } from "../MyComponents/PermissionHandler";
import { useSelector } from "react-redux";
import EditContactUs from "./editcontactus";

const ContactUS = () => {
  const GlobalState = useSelector((state) => state.access_control);
  const [dataSource, setDataSource] = useState([]);
  const [Selecteddata, setSelecteddata] = useState(null);
  const [Search, setSearch] = useState("");
  const [showSave, setShowSave] = useState(0);

  const fetchData = async () => {
    setSelecteddata(null);
    const res = await GetRequest(`${ApiUrl.configuration}${ConfUrl.contact}`);
    if (res) {
      setDataSource(res?.value?.country ?? []);
    }
    setShowSave(0);
  };

  const changeDataSource = (dt) => {
    setDataSource(dt);
    setShowSave(1);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const RemoveData = async (id) => {
    let req = dataSource.filter((item) => item.key !== id);
    const resp = await PatchRequest(
      `${ApiUrl.configuration}${ConfUrl.contact}`,
      { country: req }
    );
    if (resp) {
      DeletConfirmation();
      fetchData();
    }
  };

  const SaveReordering = async () => {
    setShowSave(2);
    const resp = await PatchRequest(
      `${ApiUrl.configuration}${ConfUrl.contact}`,
      { country: dataSource }
    );
    if (resp) {
      fetchData();
    }
  };

  const renderRefreshTooltip = (props, Data) => (
    <Tooltip id="refresh-tooltip" {...props}>
      {Data}
    </Tooltip>
  );

  const CountryKeys = {
    contact_usa: "USA",
    contact_ger: "Germany",
    contact_ner: "Netherlands",
    contact_italy: "Italy",
    contact_uk: "UK",
    contact_france: "France",
    contact_china: "China",
    contact_sing: "Singapore",
    contact_uae: "Uae",
  };

  const columns = [
    {
      title: "Country",
      dataIndex: "countryIdentifier",
      // render: (data) => CountryKeys[data],
    },
    {
      title: "Heading",
      dataIndex: "heading",
    },
    {
      title: "Map",
      dataIndex: "mapElement",
      render: (data) => CountryKeys[data],
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Address 1",
      dataIndex: "address1",
    },
    {
      title: "Address 2",
      dataIndex: "address2",
    },
    {
      title: "Phone",
      dataIndex: "phone",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      align: "center",
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <OverlayTrigger
              placement="top"
              overlay={(d) => renderRefreshTooltip(d, "Edit")}
            >
              {PermissionHandler(GlobalState, "career", "UPDATE") && (
                <Link
                  className="me-2 p-2"
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#edit-units"
                  onClick={() => setSelecteddata(record)}
                >
                  <i data-feather="edit" className="feather-edit"></i>
                </Link>
              )}
            </OverlayTrigger>
            <OverlayTrigger
              placement="top"
              overlay={(d) => renderRefreshTooltip(d, "Delete")}
            >
              {PermissionHandler(GlobalState, "career", "DELETE") && (
                <Link
                  className="confirm-text p-2"
                  to="#"
                  onClick={() =>
                    showDeleteConfirmationAlert(record.key, RemoveData)
                  }
                >
                  <i data-feather="trash-2" className="feather-trash-2"></i>
                </Link>
              )}
            </OverlayTrigger>
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Contact Us</h4>
                <h6>Manage your Contact us details</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={(d) => renderRefreshTooltip(d, "Refresh")}
                >
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    onClick={fetchData}
                  >
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
            <div className="page-btn">
              {PermissionHandler(GlobalState, "career", "WRITE") && (
                <a
                  to="#"
                  className="btn btn-added"
                  data-bs-toggle="modal"
                  data-bs-target="#edit-units"
                >
                  <PlusCircle className="me-2" />
                  Add New Address
                </a>
              )}
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control form-control-sm formsearch"
                      value={Search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <Link to className="btn btn-searchset">
                      <i data-feather="search" className="feather-search" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="table-responsive">
                <Table
                  columns={columns}
                  dataSource={dataSource}
                  setDataSource={changeDataSource}
                />
              </div>
            </div>
          </div>
          {showSave > 0 && (
            <div className="col-lg-12">
              <div className="btn-addproduct mb-4">
                <button
                  className="btn btn-submit"
                  // disabled={isSubmitting}
                  onClick={SaveReordering}
                >
                  {showSave === 2 ? (
                    <span className="spinner-border spinner-border-sm"></span>
                  ) : (
                    "Save Changes"
                  )}
                </button>
              </div>
            </div>
          )}
          {/* /product list */}
        </div>
        {/* <AddContactUs OnFinish={fetchData} /> */}

        <EditContactUs
          OnFinish={fetchData}
          editData={Selecteddata}
          fulldata={dataSource}
        />
      </div>
    </>
  );
};

export default ContactUS;
